<template>
    <b-modal
            :visible="showModal === 'problemOrder'"
            @hidden="hideProblemModal"
            :lazy="true"
            >
        <div slot="modal-title">
            <h4 v-if="order" class="modal-title">Сообщить о проблеме с заказом № {{order.id}}</h4>
        </div>
        <loading v-if="loading" :size="3" message="Сообщаем о проблеме..."></loading>
        <form v-else сlass="form-horizontal" @submit.prevent="problem">
            <div class="form-group" :class="{ 'has-danger': $v.text.$error }">
                <label class="form-control-label" for="cancel-input">Описание проблемы</label>
                <textarea ref="focusThis" id="cancel-input"  rows="4" v-model="text" @input="$v.text.$touch()" class="form-control" placeholder="Подробно опишите почему этот заказ проблемный, например: 'Клиент не приехал в назначенное время', 'Нет оборудования', 'Все занято не можем принять' и т.д."></textarea>
                <span class="small help-block text-danger" v-if="$v.text.$error">Пожалуйста опишите проблему</span>
            </div>
        </form>
        <div slot="modal-footer" >
            <b-btn v-if="!loading" @click.prevent="hideProblemModal">Ничего не делать</b-btn>
            <b-btn v-if="!loading" variant="warning" :class="{ 'disabled': $v.text.$invalid }" :disabled="$v.text.$invalid" @click.prevent="problem">Сообщить о проблеме</b-btn>
        </div>
    </b-modal>
</template>
<script>
  import { required, minLength } from 'vuelidate/lib/validators'
  import { mapState, mapActions } from 'vuex'
  import { ADD_TOAST_MESSAGE } from 'vuex-toast'
  export default {
    computed: mapState({
      showModal: state => state.orderStore.showModal,
      order: state => state.orderStore.editOrder
    }),
    data () {
      return {
        text: '',
        loading: false
      }
    },
    methods: {
      problem () {
        this.loading = true
        this.$store.dispatch('problemOrder', {
          cause: this.text,
          value: true,
          orderId: this.order.id
        }).then((data) => {
          this.loading = false
          this.text = ''
          this.$store.commit('SET_SHOW_ORDER_MODAL', null)
          this.addToast({
            text: 'Заказ успешно переведен в проблемные',
            type: 'success',
            dismissAfter: 3000
          })
        }).catch((error) => {
          this.loading = false
          this.addToast({
            text: 'Произошла ошибка при установке статуса проблемный:' + error,
            type: 'danger',
            dismissAfter: 10000
          })
        })
      },
      hideProblemModal (e) {
        this.$store.dispatch('setEditOrder', null)
        this.$store.commit('SET_SHOW_ORDER_MODAL', null)
      },
      ...mapActions({
        addToast: ADD_TOAST_MESSAGE
      })
    },
    validations: {
      text: {
        required,
        minLength: minLength(5)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// ModalProblemOrder.vue?bca1a542